import { z } from 'zod';

import { BannerMessageId } from '../BrandedIds';
import { zodBrandedUuid, zodDateOrString } from '../utils';

export const BannerMessage = z.object({
  id: zodBrandedUuid<BannerMessageId>(),
  message: z.string(),
  isActive: z.boolean(),
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});

export type BannerMessage = z.infer<typeof BannerMessage>;
